import { HTTPInstance } from "@http/http-instance";
import { Dish, DishCategory } from "./DishesAPI.model";

export const getDishes = async (restaurantId: string): Promise<Dish[]> => {
  const { data } = await HTTPInstance.get<Dish[]>(
    `/public/restaurants/${restaurantId}/dishes`,
  );
  return data;
};

export const getCategories = async (
  restaurantId: string,
): Promise<DishCategory[]> => {
  const { data } = await HTTPInstance.get<DishCategory[]>(
    `/public/restaurants/${restaurantId}/categories`,
  );
  return data;
};
